import React, { Component } from 'react';

class Social extends Component {
  render(){

    return(
      <div>
        <h4 className="social-heading no-margin">Connect</h4>
          <ul className="social-links">
            <li>
                <a className="social-link" href="https://www.facebook.com/basildononline" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-facebook-square fa-2x" aria-hidden="true"></i>
                  <span className="sr-only">Facebook</span>
                </a>
              </li>
              <li>
                <a className="social-link" href="https://www.twitter.com/basildon_online" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-twitter-square fa-2x" aria-hidden="true"></i>
                  <span className="sr-only">Twitter</span>
                </a>
              </li>
              
          </ul>
      </div>
    );
  }
}
export default Social;


// WEBPACK FOOTER //
// ./src/components/blocks/Social.js